export class RecruiterList {
  sno: number;
  recruiter_id: any;
  phone: any;
  recruiter_name: any;
  status?: any;
  result?: any;
  employee_id?: any;
  id: any;
}
export class BulkRecruiter {
  file: any;
}

export class Studies {
  responseCode: any;
  result: StudiesDetail;
}
export class RecruiterStudy {
  responseCode: any;
  result: RecruiterDetail;
}
export class RecruiterDetail {
  recruiter_name: string;
  phone: number;
  id: string;
  recruiter_code: string;
}
export class StudiesDetail {
  organization_name: string;
  project_name: string;
  id: string;
  study_name: string;
  study_status: string;
  roles: any;
}
export class Recruiter {
  recruiter_name: any;
  phone: any;
  employee_id?: any;
  recruiter_code: any;
  code?: any;
  id?: any;
  location?: any;
  name?: any;

  constructor(values: Object = {}) {
    Object.assign(this, values);
  }

}
